import { RouterProvider } from 'react-router-dom'
import routerConfig from './router'
import 'antd/dist/reset.css'
import './App.css'
import UpdateNotification from './components/tipsComponent'

function App() {
  return <>
      <UpdateNotification />
      <RouterProvider router={routerConfig}></RouterProvider>
  </>
  
  
}

export default App
